import React from "react";
import {
  DonutLargeOutlined,
  LooksOneOutlined,
  LooksTwoOutlined,
} from "@mui/icons-material";
import { Box, Grid, Typography } from "@mui/material";

import InformationTile from "components/Shared/InformationTile";
import InfoGridSkeleton from "components/Shared/Skeleton/InfoGridSkeleton";
import Status from "components/Shared/Status";

import { useCountryDetailContext } from "contexts/CountryDetailContext";

export const CountryBasicDetail = () => {
  const { countryDetail, loadingCountry } = useCountryDetailContext();

  return !loadingCountry ? (
    <Box padding={3}>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Typography variant="h6">{countryDetail?.name}</Typography>
        </Grid>

        <Grid item md={3}>
          <InformationTile
            icon={() => <LooksOneOutlined color="primary" />}
            title="CCA2"
            subtitle={countryDetail?.cca2}
          />
        </Grid>

        <Grid item md={3}>
          <InformationTile
            icon={() => <LooksTwoOutlined color="primary" />}
            title="CCA3"
            subtitle={countryDetail?.cca3}
          />
        </Grid>

        <Grid item md={3}>
          <InformationTile
            icon={() => <DonutLargeOutlined color="primary" />}
            title="Status"
          >
            <Status isActive={countryDetail?.isActive} />
          </InformationTile>
        </Grid>
      </Grid>
    </Box>
  ) : (
    <InfoGridSkeleton />
  );
};
